// extracted by mini-css-extract-plugin
export default {"zoomModal":"F2-z"};